/**
 * AuditLogShell
 *
 * Right-hand audit log card frame shared by per-game-type admin Results
 * tabs. Owns the card styling, the title + event-count header, and the
 * empty-state. Each game type renders its own event row layout as
 * children (event field shapes differ per game).
 */

import { ReactNode } from 'react';

export interface AuditLogShellProps {
  title?: string;
  eventCount: number;
  emptyMessage?: string;
  children: ReactNode;
}

export function AuditLogShell({
  title = 'Audit Log',
  eventCount,
  emptyMessage = 'No events yet.',
  children,
}: AuditLogShellProps) {
  return (
    <div className="bg-space bg-o-50 text-white border-md border-blue-light rounded-base p-sm d-flex flex-column gap-xs">
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="text-cyan">{title}</h4>
        <span className="text-slate ff-display fs-sm">{eventCount} events</span>
      </div>

      <div className="d-flex flex-column gap-2xs ff-display fs-sm">
        {eventCount === 0 ? <span className="text-cyan">{emptyMessage}</span> : children}
      </div>
    </div>
  );
}
